"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.LargeInfoStatusIcon = function () { return (react_1.default.createElement("svg", { viewBox: "0 0 32 32", width: "32", height: "32" },
    react_1.default.createElement("circle", { fill: "#4997c7", cx: "16", cy: "16", r: "16" }),
    react_1.default.createElement("path", { fill: "#fff", d: "M14.581,26.007V12.524h3V26.007Z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "M16.081,6a2,2,0,1,0,2,2A2,2,0,0,0,16.081,6Z" }))); };
//# sourceMappingURL=LargeInfoStatusIcon.js.map